$(function () {
    if ($("#rd-section-ser1").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-ser1",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-ser1").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-ser2").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-ser2",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-ser2").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-ser3").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-ser3",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-ser3").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-ser4").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-ser4",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-ser4").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-ser5").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-ser5",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-ser5").addClass("ani_do").removeClass("op0");
            },
        });
    }
});
